import React, {Component} from "react";
import NavBar from "./NavBar";
import { Link } from "react-router-dom";


class Home extends Component {
    render(){
        return(
            <div>
                < NavBar/>
                <h2>
                    Welcome to Agent Afrika. Register as a partner <Link to="/apply">here.</Link>
                </h2> 
            </div>
        )
    }

}

export default Home;